/**
 * ThemeToggle — переключение светлой и тёмной темы.
 *
 * Кнопка показывает иконку той темы, в которую переключит: на светлой — луну,
 * на тёмной — солнце. Так по кнопке понятно, что произойдёт по клику, без
 * подписи и без выпадающего списка.
 *
 * Размер 36×36 совпадает с кнопкой языка и аватаром в шапке.
 */
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useThemeStore } from '@/store/themeStore';

export function ThemeToggle() {
  const { t } = useTranslation();
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);

  const nextIsDark = theme === 'light';
  const label = t(nextIsDark ? 'theme.switchToDark' : 'theme.switchToLight');

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="btn-ghost w-9 h-9 p-0"
      title={label}
      aria-label={label}
    >
      {nextIsDark ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
